import React, { useContext, useEffect, useState } from "react";
import { fetchUserOrder } from "../api/usersApi";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import Modal from "react-modal";
import { fetchOrder } from "../api/adminApi";
import placeholder from "../assets/images/product-placeholder.png";

const Orders = () => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const { user, dispatch } = useContext(Context);

  const formattingOption = {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  };

  useEffect(() => {
    const handleFetchOrders = async () => {
      if (user?.id) {
        setLoading(true);
        try {
          const res = await fetchUserOrder(user?.id, user?.accessToken);
          setOrders(res.data);
        } catch (err) {
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        } finally {
          setLoading(false);
        }
      }
    };

    handleFetchOrders();
  }, [dispatch, user?.id, user?.accessToken]);

  const handleMoreDetails = async (orderId) => {
    setModalIsOpen(true);
    setModalLoading(true);
    try {
      const res = await fetchOrder(user?.accessToken, orderId);
      setSelectedOrder(res.data);
    } catch (err) {
      const message =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        err.toString();
      toast.error(message);
      setModalIsOpen(false);
    } finally {
      setModalLoading(false);
    }
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setSelectedOrder(null);
  };

  return (
    <div className="profile__main" style={{ padding: 30 }}>
      {/* Order Details Modal */}
      <Modal
        className="modalMain"
        overlayClassName="modal-overlayCenter"
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
      >
        <div className="orderModal">
          <button className="orderModal__close" onClick={handleCloseModal}>
            ✕
          </button>

          {modalLoading ? (
            <Loading />
          ) : (
            <>
              <h2 className="orderModal__title">Order Details</h2>

              <div className="cart__main__total" style={{ marginTop: 20 }}>
                <div className="cart__main__total__part">
                  <b>Products</b>
                </div>

                {selectedOrder?.items?.map((product) => (
                  <div key={product.id} className="cart__main__total__part">
                    <span>
                      <img
                        style={{ width: 70, marginRight: 10 }}
                        src={
                          product?.product?.imgMain
                            ? process.env.REACT_APP_API_URL +
                              product?.product?.imgMain
                            : placeholder
                        }
                        alt={product?.name}
                      />
                      {product?.name} <b>× {product?.quantity}</b>
                    </span>
                    {(product?.price * product?.quantity).toLocaleString(
                      "en-NG",
                      formattingOption,
                    )}
                  </div>
                ))}

                <div className="cart__main__total__part">
                  <b>Date</b>
                  {selectedOrder?.createdAt?.slice(0, 10)}
                </div>

                <div className="cart__main__total__part">
                  <b>Payment ID</b>
                  {selectedOrder?.paymentId}
                </div>

                <div className="cart__main__total__part">
                  <b>Payment Status</b>
                  <p
                    className={`account__main__order__table__row__data__status ${
                      selectedOrder?.paymentStatus === "Success"
                        ? "status--success"
                        : selectedOrder?.paymentStatus === "Failed"
                          ? "status--failed"
                          : "status--initiated"
                    }`}
                  >
                    {selectedOrder?.paymentStatus === "Initiated"
                      ? "Pending"
                      : selectedOrder?.paymentStatus}
                  </p>
                </div>

                <div className="cart__main__total__part">
                  <b>Order Status</b>
                  {selectedOrder?.status}
                </div>

                <div className="cart__main__total__part">
                  <b>Shipping Method</b>
                  {selectedOrder?.shippingMethod}
                </div>

                {selectedOrder?.orderNote && (
                  <div className="cart__main__total__part">
                    <b>Order Note</b>
                    {selectedOrder?.orderNote}
                  </div>
                )}

                <div className="cart__main__total__part">
                  <b>Total</b>
                  <b>
                    {selectedOrder?.bill?.toLocaleString(
                      "en-NG",
                      formattingOption,
                    )}
                  </b>
                </div>
              </div>

              <div className="cart__main__total" style={{ marginTop: 30 }}>
                <div className="cart__main__total__part">
                  <b>Shipping/Billing Details</b>
                </div>

                <div className="cart__main__total__part">
                  <b>Name</b>
                  {selectedOrder?.billingAddress?.firstName}{" "}
                  {selectedOrder?.billingAddress?.lastName}
                </div>

                <div className="cart__main__total__part">
                  <b>Phone</b>
                  {selectedOrder?.billingAddress?.phone}
                </div>

                <div className="cart__main__total__part">
                  <b>Email</b>
                  {selectedOrder?.billingAddress?.email}
                </div>

                <div className="cart__main__total__part">
                  <b>Company Name</b>
                  {selectedOrder?.billingAddress?.companyName}
                </div>

                <div className="cart__main__total__part">
                  <b>Address</b>
                  {selectedOrder?.billingAddress?.streetAddress}
                  {selectedOrder?.billingAddress?.streetAddressOpt &&
                    `, ${selectedOrder?.billingAddress?.streetAddressOpt}`}
                </div>

                <div className="cart__main__total__part">
                  <b>City / State</b>
                  {selectedOrder?.billingAddress?.city},{" "}
                  {selectedOrder?.billingAddress?.state}
                </div>

                <div className="cart__main__total__part">
                  <b>ZIP Code</b>
                  {selectedOrder?.billingAddress?.zipCode}
                </div>

                <div className="cart__main__total__part">
                  <b>Country</b>
                  {selectedOrder?.billingAddress?.country}
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>

      <div className="account__main__order">
        <h3>Order History</h3>

        <div className="account__main__order__table">
          <div
            className="account__main__order__table__body"
            style={{ minWidth: 800 }}
          >
            <div className="account__main__order__table__row head">
              <div
                style={{ width: "350px" }}
                className="account__main__order__table__row__head"
              >
                Order ID
              </div>
              <div
                style={{ width: "100px" }}
                className="account__main__order__table__row__head"
              >
                Date
              </div>
              <div
                style={{ width: "150px" }}
                className="account__main__order__table__row__head"
              >
                Payment ID
              </div>
              <div
                style={{ width: "150px" }}
                className="account__main__order__table__row__head"
              >
                Payment Status
              </div>
              <div
                style={{ width: "100px" }}
                className="account__main__order__table__row__head"
              >
                Order Status
              </div>
              <div
                style={{ width: "180px" }}
                className="account__main__order__table__row__head"
              >
                Total
              </div>
              <div
                style={{ width: "150px" }}
                className="account__main__order__table__row__head"
              ></div>
            </div>

            {loading ? (
              <Loading />
            ) : orders.length === 0 ? (
              <p style={{ padding: "20px 0", color: "#999" }}>
                No orders found.
              </p>
            ) : (
              orders.map((order) => (
                <div
                  key={order.id}
                  className="account__main__order__table__row"
                >
                  <div
                    style={{ width: "350px" }}
                    className="account__main__order__table__row__data"
                  >
                    {order?.id}
                  </div>
                  <div
                    style={{ width: "100px" }}
                    className="account__main__order__table__row__data"
                  >
                    {order?.createdAt?.slice(0, 10)}
                  </div>
                  <div
                    style={{ width: "150px" }}
                    className="account__main__order__table__row__data"
                  >
                    {order?.paymentId}
                  </div>
                  <div
                    style={{ width: "150px" }}
                    className="account__main__order__table__row__data"
                  >
                    <p
                      className={`account__main__order__table__row__data__status ${
                        order?.paymentStatus === "Success"
                          ? "status--success"
                          : order?.paymentStatus === "Failed"
                            ? "status--failed"
                            : "status--initiated"
                      }`}
                    >
                      {order?.paymentStatus === "Initiated"
                        ? "Pending"
                        : order?.paymentStatus}
                    </p>
                  </div>
                  <div
                    style={{ width: "100px" }}
                    className="account__main__order__table__row__head"
                  >
                    {order?.status}
                  </div>
                  <div
                    style={{ width: "180px" }}
                    className="account__main__order__table__row__data"
                  >
                    {order?.bill.toLocaleString("en-NG", formattingOption)}
                  </div>
                  <div
                    style={{ width: "150px" }}
                    className="account__main__order__table__row__data"
                  >
                    <button onClick={() => handleMoreDetails(order.id)}>
                      More Details
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
